/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      logger.debug(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      logger.debug('Service worker has been registered.')
    },
    cached () {
      logger.debug('Content has been cached for offline use.')
    },
    updatefound () {
      logger.debug('New content is downloading.')
    },
    updated () {
      logger.debug('New content is available; please refresh.')
    },
    offline () {
      logger.debug('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
